var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMentalHealthSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19605_50887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.96752 15.0381C13.2955 15.0381 15.9934 12.3402 15.9934 9.0122C15.9934 5.6842 13.2955 2.98633 9.96752 2.98633C6.63953 2.98633 3.94165 5.6842 3.94165 9.0122C3.94165 12.3402 6.63953 15.0381 9.96752 15.0381Z",
    fill: "#81CFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0132 6.5625C12.0132 5.52697 11.1737 4.6875 10.1382 4.6875C9.10265 4.6875 8.26318 5.52697 8.26318 6.5625C8.26318 7.59803 9.38818 8.25 10.1382 8.4375C10.7579 8.59242 11.3776 9.13137 11.1511 9.94856",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48804 6.71942C5.48804 9.29137 6.47169 11.2836 8.97553 12C11.4794 12.7164 10.2163 13.6826 10.8534 14.9586C11.7477 16.7497 13.9989 15.8264 14.4303 14.2421C14.8618 12.6579 13.8256 11.9753 13.888 10.5C13.9522 8.98369 14.788 9.29137 14.788 6.71942C14.788 4.14748 12.7062 2.0625 10.138 2.0625C7.56991 2.0625 5.48804 4.14748 5.48804 6.71942Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26294 3C3.5669 4.08129 3.16309 5.36849 3.16309 6.75C3.16309 7.82457 3.40739 8.84207 3.8435 9.75",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19605_50887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9755,
    height: 18,
    fill: "white",
    transform: "translate(0.975586)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentalHealthSupport);
export default __webpack_public_path__ + "static/media/mental_health_support.7a5c13c26269720a15adfc0bf618478f.svg";
export { ForwardRef as ReactComponent };